// extracted by mini-css-extract-plugin
module.exports = {"SectionList":"SectionList_SectionList__BdGMr"};